<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="js">
import { useAutonodeStore } from '@/stores/autonode.store';
import { storeToRefs } from 'pinia';
import { useNodeStore } from '@/stores/node.store';
import useModal from '@/stores/modal.store';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import DirectionOrgModal from '@/components/modals/Autonode/DirectionOrgModal.vue';
import _ from 'lodash';

const nodeStore = useNodeStore();
const autonodeStore = useAutonodeStore();
const { custom_variables, directionOrgs, selectedDirectionOrgIndex } =
  storeToRefs(autonodeStore);
const { activeModal, closeModal } = useModal();

function getDirectionName(directionId) {
  const childrens = _.keyBy(nodeStore.bpNode.child_directions, 'id');
  return childrens?.[directionId]?.next_bp_node?.current?.node?.name || 'Узел не найден';
}

function getVariableTitle(variableName) {
  let variable = custom_variables.value.find((v) => v.name == variableName);
  return variable?.title || '';
}

function openUpdateModal(index) {
  selectedDirectionOrgIndex.value = index;
  activeModal.value = 'DirectionOrgModal';
}

function openDeleteModal(index) {
  selectedDirectionOrgIndex.value = index;
  activeModal.value = 'deleteModal';
}

function deleteDirectionOrg() {
  directionOrgs.value.splice(selectedDirectionOrgIndex.value, 1);
  closeModal();
}
</script>

<template>
  <div class="autoform-variables">
    <div class="d-flex justify-content-between align-items-center input-btns">
      <div
        class="add-btn"
        @click="activeModal = 'DirectionOrgModal'"
      >
        <img src="@/assets/img/plus-ico.svg" alt="plus-ico.svg" />
        Добавить организацию на направление
      </div>
    </div>
    <div></div>
    <div class="table-responsive">
      <table class="table gray-table">
        <thead>
          <tr>
            <th>Направление</th>
            <th>Переменная (БИН)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(directionOrg, index) in directionOrgs" :key="index">
            <td>
              {{ getDirectionName(directionOrg.direction_id) }}
            </td>
            <td>
              {{ getVariableTitle(directionOrg.variable) }}
            </td>
            <td>
              <div class="table-buttons">
                <div class="table-button" @click="openUpdateModal(index)">
                  <span class="edit-ico" />
                </div>
                <div class="table-button" @click="openDeleteModal(index)">
                  <span class="delite-ico" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <DeleteModal
    v-if="activeModal === 'deleteModal'"
    :itemText="'это направление'"
    @confirmDelete="deleteDirectionOrg()"
  />
  <DirectionOrgModal v-if="activeModal === 'DirectionOrgModal'" />
</template>
